'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$() {
  this.aTt = null;
  this.aTK = null;
  this.aTw = null;
  this.aTx = false;
  this.aTC = null;
  this.aTD = false;
  this.aTI = null;
  this.aTJ = false;
  this.aTu = null;
  this.aTv = false;
  this.aTG = null;
  this.aTH = false;
  this.aTE = null;
  this.aTF = false;
  this.aTy = null;
  this.aTz = false;
  this.aTA = null;
  this.aTB = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$ = this;
  this.aTt = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$();
  this.aTK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$.prototype = $p;
$p.eR = (function() {
  return this.aTt;
});
$p.eO = (function() {
  return this.aTK;
});
$p.bW = (function() {
  if ((!this.aTx)) {
    this.aTw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aTx = true;
  }
  return this.aTw;
});
$p.b9 = (function() {
  if ((!this.aTD)) {
    this.aTC = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aTD = true;
  }
  return this.aTC;
});
$p.b3 = (function() {
  if ((!this.aTJ)) {
    this.aTI = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aTJ = true;
  }
  return this.aTI;
});
$p.aG = (function() {
  if ((!this.aTv)) {
    this.aTu = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aTv = true;
  }
  return this.aTu;
});
$p.az = (function() {
  if ((!this.aTH)) {
    this.aTG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aTH = true;
  }
  return this.aTG;
});
$p.aY = (function() {
  if ((!this.aTF)) {
    this.aTE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aTF = true;
  }
  return this.aTE;
});
$p.Jo = (function() {
  if ((!this.aTz)) {
    this.aTy = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Voyage";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aTz = true;
  }
  return this.aTy;
});
$p.bsq = (function() {
  if ((!this.aTB)) {
    this.aTA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aTB = true;
  }
  return this.aTA;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$, "app.data.data_point_types$package$VoyageForm$", ({
  GI: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$() {
  this.aTr = null;
  this.aTs = false;
  this.aTp = null;
  this.aTq = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$.prototype = $p;
$p.aA = (function() {
  if ((!this.aTs)) {
    this.aTr = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aTs = true;
  }
  return this.aTr;
});
$p.bs8 = (function() {
  if ((!this.aTq)) {
    this.aTp = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$VoyageForm$().Jo();
    this.aTq = true;
  }
  return this.aTp;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$, "app.data.data_point_types$package$Voyage$", ({
  GH: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Voyage$ };
//# sourceMappingURL=app.data.data_point_types$package$-Voyage$.js.map
